import { onMounted, onUnmounted, ref, watch, computed } from 'vue'
import { useUserStore } from '@/stores/user'

enum ThemeClass {
  LIGHT = 'theme-light',
  DARK = 'theme-dark',
  BLACK = 'theme-black',
}

export function useColorScheme() {
  const userStore = useUserStore()
  const isDarkTheme = ref(getIsDarkTheme())

  const themeClass = computed(() => {
    const userTheme = userStore.settings.additional.theme
    if (userTheme === 'black') return ThemeClass.BLACK
    if (userTheme === 'dark') return ThemeClass.DARK
    if (userTheme === 'light') return ThemeClass.LIGHT
    // system or default
    return isDarkTheme.value ? ThemeClass.DARK : ThemeClass.LIGHT
  })

  function getIsDarkTheme() {
    const userTheme = userStore.settings.additional.theme
    const prefersDark = window.matchMedia(
      '(prefers-color-scheme: dark)'
    ).matches

    return (
      ['dark', 'black'].includes(userTheme) ||
      (userTheme === 'system' && prefersDark)
    )
  }

  function updateTheme() {
    isDarkTheme.value = getIsDarkTheme()
  }

  onMounted(() => {
    updateTheme()
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .addEventListener('change', updateTheme)
  })

  onUnmounted(() => {
    window
      .matchMedia('(prefers-color-scheme: dark)')
      .removeEventListener('change', updateTheme)
  })

  watch(() => userStore.settings.additional.theme, updateTheme)

  return {
    isDarkTheme,
    themeClass,
  }
}
